import React from "react";
import { sendError } from "../helpers/sendError";

export const useSendError = (error: string | null, id?: string) => {
  React.useEffect(() => {
    if (error) sendError(error, id);
  }, [error]);
};
